"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const hooks_1 = require("../../../hooks");
const react_2 = tslib_1.__importDefault(require("react"));
const useFeatureSettingsMutation_1 = require("../UserDetail/UserDetailAdminSettings/useFeatureSettingsMutation");
exports.AdsManagerFeatureFlagToggle = () => {
    const { featureFlags, currentUser: { id, featureFlagOverrides: userFeatureFlagOverrides }, } = hooks_1.useOsmosysContext();
    const { setFeatureFlags, featureFlagsSaveResult, stickiedSuccess, } = useFeatureSettingsMutation_1.useFeatureSettingsMutation(id, userFeatureFlagOverrides, 1000);
    if (featureFlags.adsManager === null) {
        return null;
    }
    return (react_2.default.createElement(react_1.OsmosysDiv, { flexColCentered: true },
        react_2.default.createElement(react_1.OsmosysToggler, { onLabel: "", offLabel: "Toggle Ads Manager Beta", on: featureFlags.adsManager, id: "adsManagerFeature", disabled: featureFlagsSaveResult.loading || stickiedSuccess, toggle: () => {
                setFeatureFlags({
                    adsManager: !featureFlags.adsManager,
                });
            } })));
};
//# sourceMappingURL=AdsManagerFeatureFlagToggle.js.map